module.exports = __webpack_public_path__ + "static/media/envelop.21c4155e.svg";